<div class="reviewers-container">

  <!-- ===== Top section: Reviewer(s) ===== -->
  <div class="section-label">{{ 'REVIEWERS' | translate }}</div>

  <div class="table-scroll">
    <table mat-table [dataSource]="reviewersDataSource" [trackBy]="trackByEmail" class="full-width">

      <!-- Role Column -->
      <ng-container matColumnDef="role">
        <th mat-header-cell *matHeaderCellDef>{{ 'MENU_FILE_PROPERTIES_ESTIMATE_COLLABORATION_ROLE' | translate }}</th>
        <td mat-cell *matCellDef="let element">{{ element.reviewerType }}</td>
      </ng-container>

      <!-- Reviewer Column -->
      <ng-container matColumnDef="reviewer">
        <th mat-header-cell *matHeaderCellDef>{{ 'REVIEW_HEADER_REVIEWER' | translate }}</th>
        <td mat-cell *matCellDef="let element">{{ element.reviewerName }}</td>
      </ng-container>

      <!-- Email Column -->
      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef>{{ 'MENU_FILE_PROPERTIES_ESTIMATE_COLLABORATION_EMAIL' | translate }}</th>
        <td mat-cell *matCellDef="let element">{{ element.reviewerEmail }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="reviewersColumns" class="row-height"></tr>
      <tr mat-row *matRowDef="let row; columns: reviewersColumns;"
          (click)="onReviewerRowClick(row)"
          [class.selected]="reviewersSelection.isSelected(row)"
          class="row-height">
      </tr>
    </table>
  </div>

  <!-- ===== Add / Remove buttons ===== -->
  <div class="action-buttons">
    <button mat-raised-button color="primary"
            [disabled]="!isAddEnabled"
            (click)="addToReviewers()">
      {{ 'ADD' | translate }} <mat-icon>arrow_upward</mat-icon>
    </button>
    <button mat-raised-button color="primary"
            [disabled]="!isRemoveEnabled"
            (click)="removeFromReviewers()">
      {{ 'REMOVE' | translate }} <mat-icon>arrow_downward</mat-icon>
    </button>
  </div>

  <!-- ===== Bottom section: Available Reviewers ===== -->
  <div class="section-label">{{ 'AVAILABLE_REVIEWERS' | translate }}</div>

  <div class="table-scroll">
    <table mat-table [dataSource]="availableDataSource" [trackBy]="trackByEmail" class="full-width">

      <!-- Role Column -->
      <ng-container matColumnDef="role">
        <th mat-header-cell *matHeaderCellDef>{{ 'MENU_FILE_PROPERTIES_ESTIMATE_COLLABORATION_ROLE' | translate }}</th>
        <td mat-cell *matCellDef="let element">{{ element.reviewerType }}</td>
      </ng-container>

      <!-- Reviewer Column -->
      <ng-container matColumnDef="reviewer">
        <th mat-header-cell *matHeaderCellDef>{{ 'REVIEW_HEADER_REVIEWER' | translate }}</th>
        <td mat-cell *matCellDef="let element">{{ element.reviewerName }}</td>
      </ng-container>

      <!-- Email Column -->
      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef>{{ 'MENU_FILE_PROPERTIES_ESTIMATE_COLLABORATION_EMAIL' | translate }}</th>
        <td mat-cell *matCellDef="let element">{{ element.reviewerEmail }}</td>
      </ng-container>

      <!-- Delete (Cross) Column -->
      <ng-container matColumnDef="delete">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <button *ngIf="availableSelection.isSelected(element)" class="delete-icon" mat-icon-button color="warn" (click)="deleteAvailableReviewer(element); $event.stopPropagation()">
            <mat-icon>delete_outline</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="availableColumns" class="row-height"></tr>
      <tr mat-row *matRowDef="let row; columns: availableColumns;"
          (click)="onAvailableRowClick(row)"
          [class.selected]="availableSelection.isSelected(row)"
          class="row-height">
      </tr>
    </table>
  </div>

  <!-- ===== Add Reviewer button ===== -->
  <div class="add-reviewer-btn">
    <button mat-raised-button color="primary" (click)="addReviewer()"><mat-icon>add</mat-icon>
      {{ 'ADD_REVIEWER' | translate }}
    </button>
  </div>

</div>
